import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAmazonProducts } from '../utils/productUtils';
import { FaSignOutAlt } from 'react-icons/fa';

const AmazonProductAdmin = () => {
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    productName: '',
    amazonLink: '',
    price: '',
    imageUrl: ''
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Load products using the utility function
    setProducts(getAmazonProducts());
  }, []);

  const saveProducts = (updatedProducts) => {
    // Save to localStorage for persistence between page reloads
    localStorage.setItem('amazonProducts', JSON.stringify(updatedProducts));
    setProducts(updatedProducts);
    setMessage('Products saved successfully!');
    setTimeout(() => setMessage(''), 3000);
  };

  const handleAddProduct = () => {
    if (!newProduct.productName || !newProduct.amazonLink || !newProduct.price) {
      setMessage('Please fill in all required fields (name, link, price)');
      return;
    }
    
    const updatedProducts = [...products, { ...newProduct }];
    saveProducts(updatedProducts);
    setNewProduct({ productName: '', amazonLink: '', price: '', imageUrl: '' });
  };

  const handleDeleteProduct = (index) => {
    const updatedProducts = [...products];
    updatedProducts.splice(index, 1);
    saveProducts(updatedProducts);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProduct({ ...newProduct, [name]: value });
  };

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];
    updatedProducts[index] = { ...updatedProducts[index], [field]: value };
    setProducts(updatedProducts);
  };

  const handleExport = () => {
    const dataStr = JSON.stringify(products, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = 'amazon-products.json';
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };
  
  const handleLogout = () => {
    // Remove admin authentication from localStorage
    localStorage.removeItem('adminAuthenticated');
    // Redirect to home page
    navigate('/');
  };

  return (
    <div className="amazon-product-admin">
      <div className="admin-header">
        <h2>Product Database for Hot Items</h2>
        <button onClick={handleLogout} className="logout-button">
          <FaSignOutAlt /> Logout
        </button>
      </div>
      
      {message && <div className="admin-message">{message}</div>}
      
      <div className="product-form">
        <h3>Add New Product</h3>
        <div className="form-group">
          <label>Product Name: *</label>
          <input
            type="text"
            name="productName"
            value={newProduct.productName}
            onChange={handleInputChange}
            placeholder="e.g., iPhone 16 Pro"
          />
        </div>
        
        <div className="form-group">
          <label>Amazon Link (with associate tag): *</label>
          <input
            type="text"
            name="amazonLink"
            value={newProduct.amazonLink}
            onChange={handleInputChange}
            placeholder="https://www.amazon.com/product/?tag=yourassociateid-20"
          />
        </div>
        
        <div className="form-group">
          <label>Price: *</label>
          <input
            type="text"
            name="price"
            value={newProduct.price}
            onChange={handleInputChange}
            placeholder="$999.99"
          />
        </div>
        
        <div className="form-group">
          <label>Image URL:</label>
          <input
            type="text"
            name="imageUrl"
            value={newProduct.imageUrl}
            onChange={handleInputChange}
            placeholder="/images/product.jpg or full URL"
          />
          <small className="form-hint">For local images, store in root/images folder and use /images/filename.jpg</small>
        </div>
        
        <button onClick={handleAddProduct}>Add Product</button>
      </div>
      
      <div className="product-list">
        <h3>Product Database</h3>
        <button onClick={handleExport} className="export-button">Export to JSON</button>
        <button onClick={() => saveProducts(products)} className="save-button">Save Changes</button>
        
        <table className="admin-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Amazon Link</th>
              <th>Price</th>
              <th>Image URL</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={product.productName}
                    onChange={(e) => handleProductChange(index, 'productName', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={product.amazonLink}
                    onChange={(e) => handleProductChange(index, 'amazonLink', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={product.price}
                    onChange={(e) => handleProductChange(index, 'price', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={product.imageUrl || ''}
                    onChange={(e) => handleProductChange(index, 'imageUrl', e.target.value)}
                    placeholder="/images/..."
                  />
                </td>
                <td>
                  <button onClick={() => handleDeleteProduct(index)} className="delete-button">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AmazonProductAdmin; 